import { Directive, OnInit, inject, input } from '@angular/core';

import { ThemeBorder, ThemeBorderRadius, ThemeElevated, ThemeInverse, injectCurrentTheme } from '@frontend/sports/common/ui/shared';
import { DsCard } from '@frontend/ui/card';

import { CardThemeVariant } from './types';

@Directive({
    selector: '[msThemedCard]',
    standalone: true,
})
export class SportsThemedCardDirective implements OnInit {
    themedInverse = input<ThemeInverse>();
    themedCardVariant = input<CardThemeVariant>();
    themeCardElevated = input<ThemeElevated>();
    themenoBorderRadius = input<ThemeBorderRadius>();
    themeNoBorder = input<ThemeBorder>();

    currentTheme = injectCurrentTheme();
    card: DsCard = inject(DsCard, {
        self: true,
    });

    ngOnInit(): void {
        const inverse = this.themedInverse()?.[this.currentTheme];
        if (inverse) {
            this.card.inverse.set(inverse.isInverse);
        }
        const variant = this.themedCardVariant()?.[this.currentTheme];
        if (variant) {
            this.card.variant.set(variant);
        }

        const elevated = this.themeCardElevated()?.[this.currentTheme];
        if (elevated) {
            this.card.elevated.set(elevated.isElevated);
        }

        const borderRadius = this.themenoBorderRadius()?.[this.currentTheme];
        if (borderRadius) {
            this.card.noBorderRadius.set(borderRadius.noBorderRadius);
        }
        const border = this.themeNoBorder()?.[this.currentTheme];
        if (border) {
            this.card.noBorder.set(border.noBorder);
        }
    }
}
